
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/why-qmee",
      function () {
        return require("private-next-pages/qmee/why-qmee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/why-qmee"])
      });
    }
  